import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-artist',
    templateUrl: './artist.component.html',
    styleUrls: ['./artist.component.scss'],
    standalone: false
})
export class ArtistComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
